"use client";

import Link from 'next/link';

export function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="w-full border-t border-gray-200 bg-white py-16 dark:border-gray-800 dark:bg-gray-950">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand/Logo Section */}
          <div className="flex flex-col space-y-4">
            <Link href="/" className="text-xl font-bold">
              TabLab
            </Link>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Powerful data analysis and visualization tools
            </p>
            <div className="flex flex-col space-y-2 mt-4">
              <Link href="/graphs" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                All Graph Makers
              </Link>
              <Link href="/statistics" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                All Statistics Calculators
              </Link>
            </div>
          </div>

          {/* Data Tools */}
          <div className="flex flex-col space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wider">Data Viewers</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/csv/view" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                CSV Viewer
              </Link>
              <Link href="/json/view" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                JSON Viewer
              </Link>
              <Link href="/tsv/view" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                TSV Viewer
              </Link>
              <Link href="/parquet/view" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Parquet Viewer
              </Link>
            </div>

            <h3 className="text-sm font-semibold uppercase tracking-wider mt-6">Data Tools</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/csv/merge" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                CSV Merge
              </Link>
              <Link href="/json/merge" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                JSON Merge
              </Link>
              <Link href="/tsv/merge" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                TSV Merge
              </Link>
              <Link href="/parquet/merge" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Parquet Merge
              </Link>
              <Link href="/csv/filter" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                CSV Filter
              </Link>
              <Link href="/csv/sort" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                CSV Sort
              </Link>
            </div>

            <h3 className="text-sm font-semibold uppercase tracking-wider mt-6">Sample Data</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/csv/sample" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                CSV Samples
              </Link>
              <Link href="/json/sample" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                JSON Samples
              </Link>
              <Link href="/tsv/sample" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                TSV Samples
              </Link>
              <Link href="/parquet/sample" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Parquet Samples
              </Link>
            </div>
          </div>

          {/* Graph Makers */}
          <div className="flex flex-col space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wider">Basic Charts</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/graphs/bar" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Bar Graph
              </Link>
              <Link href="/graphs/column" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Column Graph
              </Link>
              <Link href="/graphs/horizontal-bar" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Horizontal Bar
              </Link>
              <Link href="/graphs/line" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Line Chart
              </Link>
              <Link href="/graphs/pie" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Pie Chart
              </Link>
              <Link href="/graphs/scatter" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Scatter Plot
              </Link>
              <Link href="/graphs/area" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Area Chart
              </Link>
            </div>

            <h3 className="text-sm font-semibold uppercase tracking-wider mt-6">Statistical Charts</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/graphs/histogram" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Histogram
              </Link>
              <Link href="/graphs/box-plot" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Box Plot
              </Link>
              <Link href="/graphs/timeseries" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Time Series
              </Link>
              <Link href="/graphs/heatmap" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Heatmap
              </Link>
              <Link href="/graphs/radar" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Radar Chart
              </Link>
              <Link href="/graphs/donut" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Donut Chart
              </Link>
            </div>

            <h3 className="text-sm font-semibold uppercase tracking-wider mt-6">Advanced Charts</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/graphs/stacked-bar" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Stacked Bar
              </Link>
              <Link href="/graphs/sunburst" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Sunburst Chart
              </Link>
              <Link href="/graphs/tree" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Tree Chart
              </Link>
              <Link href="/graphs/sankey" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Sankey Diagram
              </Link>
              <Link href="/graphs/nightingale-rose" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Nightingale Rose
              </Link>
            </div>
          </div>

          {/* Statistics Calculators */}
          <div className="flex flex-col space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wider">Basic Statistics</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/statistics/mean" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Mean
              </Link>
              <Link href="/statistics/median" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Median
              </Link>
              <Link href="/statistics/mode" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Mode
              </Link>
              <Link href="/statistics/range" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Range
              </Link>
              <Link href="/statistics/standard-deviation" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Standard Deviation
              </Link>
              <Link href="/statistics/variance" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Variance
              </Link>
              <Link href="/statistics/summary" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Summary
              </Link>
            </div>

            <h3 className="text-sm font-semibold uppercase tracking-wider mt-6">Distribution Analysis</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/statistics/normal-distribution" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Normal Distribution
              </Link>
              <Link href="/statistics/binomial-distribution" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Binomial Distribution
              </Link>
              <Link href="/statistics/chi-square" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Chi-Square
              </Link>
              <Link href="/statistics/anova" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                ANOVA
              </Link>
              <Link href="/statistics/z-score" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Z-Score
              </Link>
            </div>

            <h3 className="text-sm font-semibold uppercase tracking-wider mt-6">Advanced Statistics</h3>
            <div className="flex flex-col space-y-2">
              <Link href="/statistics/correlation-coefficient" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Correlation Coefficient
              </Link>
              <Link href="/statistics/covariance" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Covariance
              </Link>
              <Link href="/statistics/confidence-interval" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Confidence Interval
              </Link>
              <Link href="/statistics/five-number-summary" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Five Number Summary
              </Link>
              <Link href="/statistics/interquartile-range" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Interquartile Range
              </Link>
              <Link href="/statistics/quartile" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Quartile
              </Link>
            </div>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="mt-12 border-t border-gray-200 pt-8 dark:border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600 dark:text-gray-400">
              &copy; {currentYear} TabLab. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link href="/legal/privacy-policy" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Privacy Policy
              </Link>
              <Link href="/legal/terms-of-service" className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
} 